var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "imSession"
  }, [_c('ImagePreview', {
    attrs: {
      "visible": _vm.showImgMask,
      "imagePreviewUrl": _vm.imgMasksrc
    },
    on: {
      "update:visible": function($event) {
        _vm.showImgMask = $event
      },
      "close": function($event) {
        _vm.showImgMask = false
      }
    }
  }), _vm._v(" "), (_vm.showSatisfySettingFlag) ? _c('mask-evaluation') : _vm._e(), _vm._v(" "), _c('im-top'), _vm._v(" "), _c('div', {
    staticClass: "sessionContent chat",
    on: {
      "scroll": _vm.scorllTop
    }
  }, [_c('ul', {
    staticClass: "chatUl"
  }, _vm._l((_vm.messageList), function(item, index) {
    return _c('div', {
      key: index
    }, [(item.type != 'EVENT' && !item.revoked) ? _c('div', {
      staticClass: "createtime"
    }, [_vm._v(_vm._s(_vm.setTime(item.time)))]) : _vm._e(), _vm._v(" "), (item.type != 'EVENT' && item.revoked) ? _c('div', {
      staticClass: "createtime",
      staticStyle: {
        "margin-bottom": "10px",
        "color": "#009688"
      }
    }, [_vm._v(_vm._s(_vm.setTime(item.time) + '  ' + '消息已被撤回'))]) : _vm._e(), _vm._v(" "), (item.sendFrom != _vm.visitorMd5Code && item.type != 'EVENT' && !item.revoked) ? _c('li', {
      staticClass: "chat-mine"
    }, [_c('div', {
      staticClass: "chat-user"
    }, [_c('img', {
      staticClass: "headerImg",
      attrs: {
        "src": item.head
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wraper"
    }, [_c('span', {
      staticClass: "userNickName",
      domProps: {
        "textContent": _vm._s(item.userNickName)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "chatContent",
      class: {
        'nobg': item.type === 'IMAGE' || item.type === 'VIDEO'
      }
    }, [(item.type !== 'WORK_ORDER') ? _c('div', {
      staticClass: "chat-text",
      class: {
        'nobg': item.type === 'IMAGE' || item.type === 'VIDEO'
      }
    }, [(item.type === 'TEXT') ? _c('div', {
      directives: [{
        name: "dompurify-html",
        rawName: "v-dompurify-html",
        value: (_vm.replaceFace(item.data)),
        expression: "replaceFace(item.data)"
      }],
      staticClass: "chat-text-Con"
    }) : (item.type === 'IMAGE') ? _c('img', {
      staticClass: "imgP",
      attrs: {
        "src": item.data
      },
      on: {
        "click": function($event) {
          _vm.magnify(item)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.type === 'WORK_ORDER') ? _c('div', {
      staticClass: "chat-text1"
    }, [_c('div', {
      ref: "wraporder",
      refInFor: true
    }, [_c('div', {
      staticClass: "order"
    }, [(!item.toDo) ? _c('work-order', {
      attrs: {
        "msgId": item.msgId,
        "workOrderId": item.data
      }
    }) : _vm._e()], 1)])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (item.sendFrom == _vm.visitorMd5Code) ? _c('li', {
      staticClass: "chat-mine2"
    }, [_c('div', {
      staticClass: "chatContent2",
      class: {
        'nobg': item.type === 'IMAGE' || item.type === 'VIDEO'
      }
    }, [_c('div', {
      staticClass: "chat-text2",
      class: {
        'imgEmpty': (item.type === 'IMAGE' || item.type === 'VIDEO') && !item.data, 'nobg': item.type === 'IMAGE' || item.type === 'VIDEO'
      }
    }, [(item.type === 'TEXT') ? _c('div', {
      directives: [{
        name: "dompurify-html",
        rawName: "v-dompurify-html",
        value: (_vm.replaceFace(item.data, true)),
        expression: "replaceFace(item.data, true)"
      }],
      staticClass: "chat-Con"
    }) : (item.type === 'IMAGE') ? _c('div', {
      staticClass: "img-box"
    }, [(item.status == 'loading') ? _c('i', {
      staticClass: "el-icon-loading loading-icon"
    }) : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "imgP",
      attrs: {
        "src": item.data
      },
      on: {
        "click": function($event) {
          _vm.magnify(item)
        }
      }
    })]) : (item.type == 'VIDEO') ? _c('div', [_c('div', {
      staticClass: "more-dialog video-container"
    }, [(item.status == 'loading') ? _c('i', {
      staticClass: "el-icon-loading loading-icon"
    }) : (item.data) ? _c('i', {
      staticClass: "player-icon icon iconfont icon-bofang"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "masking-out",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.openVideo(item)
        }
      }
    }), _vm._v(" "), (item.status == 'loading') ? _c('img', {
      attrs: {
        "src": item.data,
        "width": "100%",
        "height": "100%",
        "alt": ""
      }
    }) : (item.data) ? _c('img', {
      attrs: {
        "src": item.data.split('?')[0] + '?x-oss-process=video/snapshot,t_1,f_jpg,m_fast,ar_auto',
        "width": "100%",
        "height": "100%",
        "alt": ""
      }
    }) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "chat-user2"
    }, [_c('img', {
      staticClass: "headerImg",
      attrs: {
        "src": _vm.imgUrl + 'user_pic@2x.png'
      }
    })])]) : _vm._e()])
  })), _vm._v(" "), (_vm.emotionFlag) ? _c('div', {
    staticClass: "emotions"
  }, [_c('div', {
    staticClass: "imgwraper"
  }, _vm._l((_vm.Emotion), function(imgItem, imgIndex) {
    return _c('div', {
      key: imgIndex,
      staticClass: "emotion"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(imgItem.text)
      },
      on: {
        "click": function($event) {
          _vm.chooseEmotion(imgItem, imgIndex)
        }
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticClass: "triangle"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.endis),
      expression: "endis"
    }],
    staticClass: "sessionInput"
  }, [_c('div', {
    staticClass: "img_icon_box"
  }, [_c('img', {
    staticClass: "img_icon_btn",
    class: {
      'hidden': _vm.isIE
    },
    attrs: {
      "src": _vm.imgUrl + 'hh_icon_bq.png',
      "alt": "表情icon"
    },
    on: {
      "click": _vm.showEmotion
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img_icon_btn",
    attrs: {
      "src": _vm.imgUrl + 'hh_icon_tp.png',
      "alt": "表情icon"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img_icon_btn",
    attrs: {
      "src": _vm.imgUrl + 'hh_icon_pj.png',
      "alt": "表情icon"
    },
    on: {
      "click": _vm.showsatisfySetting
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "a-upload",
    class: {
      'a-upload-left': _vm.isIE
    }
  }, [_c('input', {
    ref: "imgfile",
    attrs: {
      "type": "file",
      "name": "file",
      "id": "file",
      "accept": "image/gif,image/jpeg,image/jpg,image/png,image/svg, video/*",
      "multiple": ""
    },
    on: {
      "change": _vm.sendImgMsg
    }
  })])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msgValue),
      expression: "msgValue"
    }],
    staticClass: "input_content",
    staticStyle: {
      "height": "50px",
      "width": "97%",
      "resize": "none"
    },
    attrs: {
      "maxlength": "140"
    },
    domProps: {
      "value": (_vm.msgValue)
    },
    on: {
      "keydown": function($event) {
        _vm.sendMsg(_vm.msgValue, $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.msgValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "CtrEnt"
  }, [_vm._v("按下Ctrl+Enter换行")]), _vm._v(" "), _c('span', {
    staticClass: "sendMsg",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    on: {
      "click": function($event) {
        _vm.sendMsg2(_vm.msgValue, $event)
      }
    }
  }, [_vm._v("发送")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.endis == false),
      expression: "endis==false"
    }],
    staticClass: "sessionInput endclass"
  }, [_vm._v("\n          对话已结束，您可以点击 "), _c('a', {
    staticStyle: {
      "color": "#319bf3",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.handleBack
    }
  }, [_vm._v(" 开始新的会话")])]), _vm._v(" "), (_vm.isVideoShow) ? _c('div', {
    staticClass: "video-dialog"
  }, [_c('div', {
    staticClass: "video-close",
    on: {
      "click": _vm.closeVideo
    }
  }, [_c('i', {
    staticClass: "el-icon-close"
  })]), _vm._v(" "), _c('div', {
    staticClass: "video-content"
  }, [_c('VideoModel', {
    attrs: {
      "src": _vm.videoUrl
    }
  })], 1)]) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3924966a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/im/imSession.vue
// module id = 9Xsi
// module chunks = 1